import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * useEntitlementsStore
 *
 * Zustand store that mirrors the entitlements slice of AuthContext.
 * V2 components read entitlementsData / profileRole from here instead of
 * AuthContext so they only re-render when entitlements actually change,
 * not on every unrelated AuthContext update.
 *
 * AuthContext syncs into this store after every successful fetchAndSetEntitlements
 * call, so both V1 (context) and V2 (store) consumers always see the same data.
 */
const useEntitlementsStore = create(
  devtools(
    (set) => ({
      // ── State ────────────────────────────────────────────────────────────
      entitlements: [],
      entitlementsData: [],
      profileRole: '',
      loadingEntitlements: true,

      // ── Actions ──────────────────────────────────────────────────────────
      setEntitlements: (data) =>
        set({ entitlements: data }, false, 'setEntitlements'),

      setEntitlementsData: (data) =>
        set({ entitlementsData: data }, false, 'setEntitlementsData'),

      setProfileRole: (role) =>
        set({ profileRole: role }, false, 'setProfileRole'),

      setLoadingEntitlements: (loading) =>
        set({ loadingEntitlements: loading }, false, 'setLoadingEntitlements'),

      clearEntitlements: () =>
        set(
          { entitlements: [], entitlementsData: [], profileRole: '', loadingEntitlements: true },
          false,
          'clearEntitlements',
        ),
    }),
    { name: 'Entitlements Store', anonymousActionType: 'entitlements' },
  ),
);

export default useEntitlementsStore;
